import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AsyncPipe, NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormTextInputComponent } from '../../form-text/main/form-text.component';
import { ShFormEmailComplexBaseComponent } from '../base-complex/form-email-complex-base.component';
import { ShFormEmailBaseComponent } from '../base-simple/form-email-base.component';

@Component({
    selector: 'sh-form-email-input',
    templateUrl: './form-email.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ShFormGroupComponent,
    ShFormEmailComplexBaseComponent,
    ReactiveFormsModule,
    NgClass,
    ShFormEmailBaseComponent,
    AsyncPipe
]
})
export class ShFormEmailInputComponent extends ShFormTextInputComponent {
    handleValidation(isValid: boolean): void {
        if (!isValid) {
            this.control.setErrors({ message: this.errorMsg });
        }
    }
}
